<template>
  <b-container fluid>
      <b-nav  tabs fill>
        <b-nav-item to="dokumente" >{{$t('Briefkasten')}}</b-nav-item>
        <b-nav-item to="einladungen" active>{{$t('Einladungen')}}</b-nav-item>
      </b-nav>
    <div role="tablist" class="mt-3">
      <einladung-zeile v-for="einladung in einladungen" v-bind:key="einladung.EINPUBMSGID" :einladung="einladung" />
    </div>
  </b-container>
</template>

<script>

import EinladungZeile from "./EinladungZeile.vue"
export default {
  name: "einladungen",
  props: {
  
  },
   data() {
    return { }
  },
  computed: {
    einladungen(){
      return this.$store.state.einladungenStore.einladungen;
    }
  },
  methods: { },
  created() {
    let self = this;
    this.$nextTick(async function() {
      self.$store.dispatch("loadEinladungen")
    });
  },
  updated() {},
  mounted() {},
  components: {
    "einladung-zeile": EinladungZeile
  },
};
</script>